/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.schools.logos'},
});

const LogosItem = () => (
  <RouteLinkItem route="midas/settings/schools/logos" title={messages.title} />
);

export default LogosItem;
